import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-10 md:py-24 bg-maternal-cream relative overflow-hidden" data-id="element-126">
      <div className="absolute -right-20 top-20 w-64 h-64 bg-maternal-amber/10 rounded-full blur-3xl" data-id="element-127"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-129">
          <div className="inline-flex items-center justify-center p-3 bg-maternal-beige rounded-full mb-6 shadow-sm border border-maternal-amber/30" data-id="element-130">
            <Sparkles className="w-6 h-6 text-maternal-orange mr-2" data-id="element-131" />
            <span className="font-bold text-maternal-brown tracking-wide uppercase text-sm" data-id="element-132">
              El Secreto del Cambio
            </span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-maternal-brown mb-8 leading-tight" data-id="element-133">
            Presentamos el{' '}
            <span className="text-maternal-orange" data-id="element-134">
              Mecanismo de Micro-Acciones
            </span>{' '}
            de 7 Días
          </h2>

          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border border-maternal-beige text-left" data-id="element-135">
            <p className="text-xl text-maternal-lightBrown leading-relaxed mb-6" data-id="element-136">
              No es una terapia larga ni una charla profunda de una noche. Es un
              sistema de{' '}
              <strong className="text-maternal-brown" data-id="element-137">
                "pequeñas grietas"
              </strong>{' '}
              diseñado para derribar su muro de defensa mediante gestos casi
              invisibles que él no podrá resistir.
            </p>
            <p className="text-lg text-maternal-lightBrown leading-relaxed" data-id="element-138">
              En lugar de forzar la conexión, creamos el ambiente exacto para
              que sea él quien baje la guardia y vuelva a acercarse a ti, paso a
              paso, día a día.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}